<template>
  <div class="no_nav_height">
    <div class="row f-row mb-2">
      <div
        class="markets-chart-title col col-12"
        style="text-align: center!important;"
      >
        Analysis:
        <span style="color: var(--textactive); font-size: 1.1rem">
          {{ Analytics["userSelections"]["selectionStr"] }}</span
        >
      </div>
    </div>
    <!-- filter div -->
    <div class="filters-front-div" v-if="showFilters">
      <CommodityFilters
        :dataFilters="Analytics['rawData']['dataFilters']"
        :dataVar="Analytics['rawData']['mergedExpoHedges']"
        :dDowns="Analytics['rawData'].dDowns"
        :showLoading="loadingAll"
        @eventOnFilteredData="onFilteredData"
        @eventOnUserFilter="onUserFilter"
        @eventOnUserShowFilters="onUserShowFilters"
      />
    </div>
    <!-- Company/Portfolio/Asset Selection -->
    <div class="row f-row mt-2 mb-2">
      <div class="col col-12">
        <CompanyPortProdSelector
          :Analytics="Analytics"
          :companies="Analytics['companies']"
          :colorTheme="colorTheme"
          :loadingAll="loadingAll"
          :companyParametersReady="companyParametersReady"
          :renderFilters="true"
          :showFilters="showFilters"
          :screenWidth="screenWidth"
          @eventOnMktRefChange="onMktRefChange"
          @eventOnUserCompany="onUserCompany"
          @eventOnUserPortfolio="onUserPortfolio"
          @eventOnUserFetchData="onUserFetchData"
          @eventOnUserAsset="onUserAsset"
          @eventOnUserShowFilters="onUserShowFilters"
          @eventOnUserSpotChange="onUserSpotChange"
          @eventOnUserFetchExpand="onUserFetchExpand"
          @eventOnUserShow="onUserShow"
          @eventOnUserZoom="onUserZoom"
          @eventOnUserYear="onUserYear"
          @eventOnUserRestoreSizes="onRestoreSizes"
        />
      </div>
    </div>

    <!-- Charts -->
    <div class="row f-row container_no_selectors_height">
      <Splitter
        class="col"
        layout="vertical"
        v-bind:class="[
          Analytics['userSelections'].expandSidebar ? 'col-9' : 'col-12',
        ]"
        @onContext="onContext"
      >
        <!-- Chart container 1 -->
        <SplitterPanel
          class="row f-row prices_height"
          :size="chartSizes.sizeSplitterChartPrices"
          :minSize="4"
          :style="`flex-basis: ${chartSizes.sizeSplitterChartPrices};`"
          v-if="isUserSelectionActive"
        >
          <div class="col col-12 no_selectors_height">
            <div class="row f-row">
              <div class="chart-title-results text-left d-flex bdr-b">
                {{
                  Analytics["userSelections"].bucket.charAt(0) +
                    Analytics["userSelections"].bucket
                      .substring(1)
                      .toLowerCase()
                }}
                {{
                  Analytics["assetType"] === "commodity" ? "prices" : "rates"
                }}&nbsp;
                <span style="color: var(--textactive)">
                  ({{
                    Analytics["assetType"] === "commodity"
                      ? Analytics["userSelections"]["includeFutures"] &&
                        !Analytics["userSelections"]["includeBasis"] &&
                        !Analytics["userSelections"]["includeRatio"]
                        ? (Analytics["userSelections"]["selectedUnderlying"][0][
                            "is_cents"
                          ]
                            ? "USc"
                            : Analytics["userSelections"][
                                "selectedUnderlying"
                              ][0]["fk_idcurrency"]) +
                          "/" +
                          Analytics["userSelections"]["selectedUnderlying"][0][
                            "fk_idunit"
                          ]
                        : Analytics["userSelections"]["selectedAsset"][0][
                            "fk_idcurrency"
                          ] +
                          "/" +
                          Analytics["userSelections"]["selectedAsset"][0][
                            "fk_idunit"
                          ]
                      : Analytics["userSelections"]["selectedAsset"][0][
                          "currency_name"
                        ]
                  }})</span
                >
                <div class="ml-auto sidebarHidden">
                  <button
                    @click="onClientExpandSidebar"
                    class="btn mr-1"
                    style="width: 12px;"
                  >
                    <i
                      class="fa fa-arrow-left"
                      v-if="!Analytics['userSelections'].expandSidebar"
                    ></i>
                    <i
                      class="fa fa-arrow-right"
                      v-if="Analytics['userSelections'].expandSidebar"
                    ></i>
                  </button>
                </div>
              </div>
            </div>
            <!-- Spinner 1 -->
            <div
              class="col col-12 text-center"
              v-if="loadingAll || Analytics['loading']['topographyCalcs']"
              style="width: 100%; top: calc(50% - 8px)!important; position: absolute;"
            >
              <QSLoading
                :isLoading="
                  loadingAll || Analytics['loading']['topographyCalcs']
                "
                :size="35"
                :colorTheme="colorTheme"
              />
            </div>
            <!-- No Data Available available 1 -->
            <div
              class="col col-12 text-center"
              v-else-if="Analytics['rawData']['zoomedData'].length === 0"
              style="width: 100%; top: calc(50% - 8px)!important; position: absolute;"
            >
              {{ noDataStr }}
            </div>
            <!--  Container chart 1 -->
            <div class="row f-row container_chart_prices" v-else>
              <!-- Chart 1 -->
              <div
                class="col col-12 container-chart_chart_quantity"
                v-if="
                  Analytics['userSelections']['selectedAnalysis'] ===
                    'derivatives'
                "
              >
                <commodity-p-derivatives
                  :Analytics="Analytics"
                  :colorTheme="colorTheme"
                  :loadingAll="loadingAll"
                  :processData="processData"
                  :renderChartSignal="renderChartSignal"
                  @onTableFormat="onTableFormat"
                  @changeInfoTable="changeInfoTable"
                  @eventOnUserShow="onUserShow"
                />
              </div>
              <div
                class="col col-12 container-chart_chart_quantity"
                v-if="
                  Analytics['userSelections']['selectedAnalysis'] ===
                    'strategies'
                "
              >
                <commodity-price-strategies
                  :Analytics="Analytics"
                  :colorTheme="colorTheme"
                  :loadingAll="loadingAll"
                  :processData="processData"
                  :renderChartSignal="renderChartSignal"
                  @onTableFormat="onTableFormat"
                  @changeInfoTable="changeInfoTable"
                  @eventOnUserShow="onUserShow"
                />
              </div>
              <div class="col col-12 container-chart_chart_quantity">
                <commodity-price
                  v-if="isUserSelectionActiveScenarios"
                  :Analytics="Analytics"
                  :colorTheme="colorTheme"
                  :loadingAll="loadingAll"
                  :processData="processData"
                  :renderChartSignal="renderChartSignal"
                  @onTableFormat="onTableFormat"
                  @eventOnUserShow="onUserShow"
                  @changeInfoTable="changeInfoTable"
                />
              </div>
            </div>
          </div>
        </SplitterPanel>
        <SplitterGutter
          v-if="isUserSelectionActive"
          :index="0"
          :_this="context"
          @resizestart="onResizePanel"
          @onResize="onResizePanel"
          @resizeend="onResizePanel"
        ></SplitterGutter>
        <!-- Chart container 2 -->
        <SplitterPanel
          class="row f-row"
          :class="classChartQty"
          :size="chartSizes.sizeSplitterChart"
          :minSize="4"
          :style="`flex-basis: ${chartSizes.sizeSplitterChart}%`"
        >
          <div class="col col-12 quantity_chart_height">
            <div class="row f-row">
              <div
                class="chart-title-results text-left d-flex bdr-b"
                style="line-height: 9px!important;"
              >
                <span style="padding-top: 4px; width: 8rem;">
                  {{
                    Analytics["assetType"] === "commodity"
                      ? "Quantities"
                      : "Notional"
                  }}
                  <span style="color: var(--textactive)">
                    ({{
                      !normalizeQty
                        ? Analytics["assetType"] === "commodity"
                          ? Analytics["userSelections"]["selectedAsset"][0][
                              "fk_idunit"
                            ]
                          : Analytics["userSelections"]["selectedAsset"][0][
                              "currency_name"
                            ].slice(0, 3)
                        : "%"
                    }})</span
                  >
                </span>
                <span class="inh ml-2">
                  <label
                    :for="'normQty'"
                    class="toggle__button_g"
                    style="height: 100%"
                    :class="{
                      actives: normalizeQty,
                    }"
                  >
                    <input
                      type="checkbox"
                      v-on:click="onUserNormalizeQty"
                      :id="'normQty'"
                    />
                    <span class="toggle__switch_g"></span>
                  </label>
                </span>
                <div class="ml-auto sidebarHidden">
                  <button
                    @click="onClientExpandSidebar"
                    class="btn mr-1"
                    style="width: 12px;"
                  >
                    <i
                      class="fa fa-arrow-left"
                      v-if="!Analytics['userSelections'].expandSidebar"
                    ></i>
                    <i
                      class="fa fa-arrow-right"
                      v-if="Analytics['userSelections'].expandSidebar"
                    ></i>
                  </button>
                </div>
              </div>
            </div>
            <!-- Spinner 2 -->
            <div
              class="col col-12 text-center"
              v-if="loadingAll"
              style="width: 100%; top: calc(50% - 8px)!important; position: absolute;"
            >
              <QSLoading
                :isLoading="loadingAll"
                :size="35"
                :colorTheme="colorTheme"
              />
            </div>
            <!-- No Data Available available 2 -->
            <div
              class="col col-12 text-center"
              v-else-if="Analytics['rawData']['zoomedData'].length === 0"
              style="width: 100%; top: calc(50% - 8px)!important; position: absolute;"
            >
              {{ noDataStr }}
            </div>
            <!--  Chart 2 -->
            <div class="row f-row container_chart_quantity" v-else>
              <div class="col col-12 container-chart_chart_quantity">
                <component
                  :is="dynamicChartQty"
                  :Analytics="Analytics"
                  :colorTheme="colorTheme"
                  :loadingAll="loadingAll"
                  :processData="processData"
                  :renderChartSignal="renderChartSignal"
                  :sUnit="
                    Analytics['assetType'] === 'commodity'
                      ? Analytics['userSelections']['selectedAsset'][0][
                          'fk_idunit'
                        ]
                      : Analytics['userSelections']['selectedAsset'][
                          'fk_idcurrency_right'
                        ]
                  "
                  :unit="
                    Analytics['assetType'] === 'commodity'
                      ? Analytics['userSelections']['selectedAsset'][0][
                          'fk_idcurrency'
                        ]
                      : Analytics['userSelections']['selectedAsset'][
                          'fk_idcurrency_left'
                        ]
                  "
                  :asset="Analytics.assetType"
                  @changeInfoTable="changeInfoTable"
                  @onTableFormat="onTableFormat"
                  @eventOnUserShow="onUserShow"
                ></component>
              </div>
            </div>
          </div>
        </SplitterPanel>
        <SplitterGutter
          :index="isUserSelectionActive ? 1 : 0"
          :_this="context"
          @resizestart="onResizePanel"
          @onResize="onResizePanel"
          @resizeend="onResizePanel"
          :eventElement="newEventElement"
          :eventParentElement="eventParentElement"
        ></SplitterGutter>
        <!-- Table container 3 -->
        <SplitterPanel
          class="row f-row table_height"
          :size="chartSizes.sizeSplitterTable"
          :minSize="4"
          :style="`flex-basis: ${chartSizes.sizeSplitterTable}%`"
        >
          <div class="col col-12 container_table">
            <div class="row f-row">
              <div
                class="chart-title-results text-left d-flex bdr-b"
                style="line-height: 9px!important;"
              >
                <span style="padding-top: 4px; width: 8rem;"
                  >Consolidated data</span
                >
                <span class="inh ml-2" v-if="isUserSelectionActiveScenarios">
                  <label
                    :for="'detailsAll'"
                    class="toggle__button_g"
                    style="height: 100%"
                    :class="{
                      actives: Analytics['userSelections'].showDetails,
                    }"
                  >
                    <input
                      type="checkbox"
                      v-on:click="onUserShowDetails"
                      :id="'detailsAll'"
                    />
                    <span class="toggle__switch_g"></span>
                  </label>
                </span>
                <div class="ml-auto sidebarHidden">
                  <button
                    @click="onClientExpandSidebar"
                    class="btn mr-1"
                    style="width: 12px;"
                  >
                    <i
                      class="fa fa-arrow-left"
                      v-if="!Analytics['userSelections'].expandSidebar"
                    ></i>
                    <i
                      class="fa fa-arrow-right"
                      v-if="Analytics['userSelections'].expandSidebar"
                    ></i>
                  </button>
                </div>
              </div>
            </div>
            <div
              class="col col-12 text-center"
              v-if="loadingAll"
              style="width: 100%; top: calc(50% - 8px)!important; position: absolute;"
            >
              <QSLoading
                :isLoading="loadingAll"
                :size="35"
                :colorTheme="colorTheme"
              />
            </div>
            <div
              class="col col-12 text-center"
              v-else-if="Analytics['rawData']['zoomedData'].length === 0"
              style="width: 100%; top: calc(50% - 8px)!important; position: absolute;"
            >
              {{ noDataStr }}
            </div>
            <template v-else>
              <component
                :is="dynamicTable"
                @changeInfoTable="changeInfoTable"
                :colorTheme="colorTheme"
                :Analytics="Analytics"
                :divName="Analytics['userSelections']['selectedAnalysis']"
                :fieldNames="Analytics['userSelections']"
                :loadingAll="loadingAll"
                :renderChartSignal="renderChartSignal"
                :showDetails="Analytics['userSelections']['showDetails']"
                :zoomedData="
                  Analytics['rawData'][
                    isUserSelectionActiveScenarios
                      ? 'zoomedData'
                      : Analytics['userSelections']['selectedAnalysis']
                  ]
                "
                :formatVar="formatVar.userHovered"
                :tableFormat="infoTable"
                :noDataStr="noDataStr"
                :sUnit="
                  Analytics['assetType'] === 'commodity'
                    ? Analytics['userSelections']['selectedAsset'][0][
                        'fk_idunit'
                      ]
                    : Analytics['userSelections']['selectedAsset'][
                        'fk_idcurrency_right'
                      ]
                "
                :unit="
                  Analytics['assetType'] === 'commodity'
                    ? Analytics['userSelections']['selectedAsset'][0][
                        'fk_idcurrency'
                      ]
                    : Analytics['userSelections']['selectedAsset'][
                        'fk_idcurrency_left'
                      ]
                "
              ></component>
            </template>
          </div>
        </SplitterPanel>
      </Splitter>
      <!-- Totals -->
      <div
        v-if="Analytics['userSelections'].expandSidebar"
        class="col col-3 no_selectors_height results-divider"
      >
        <div class="row f-row">
          <div class="chart-title-results text-left d-flex bdr-b">
            Aggregates
            <div class="ml-auto sidebarHidden">
              <button
                @click="onClientExpandSidebar"
                class="btn mr-1"
                style="width: 12px;"
              >
                <i
                  class="fa fa-arrow-left"
                  v-if="!Analytics['userSelections'].expandSidebar"
                ></i>
                <i
                  class="fa fa-arrow-right"
                  v-if="Analytics['userSelections'].expandSidebar"
                ></i>
              </button>
            </div>
          </div>
        </div>
        <component
          :is="dynamicTable"
          :Analytics="Analytics"
          :colorTheme="colorTheme"
          :divName="Analytics['userSelections']['selectedAnalysis']"
          :fieldNames="Analytics['userSelections']"
          :formatVar="formatVar.userHovered"
          :isLarge="false"
          :isTotals="true"
          :loadingAll="loadingAll"
          :noDataStr="noDataStr"
          :renderChartSignal="renderChartSignal"
          :showDetails="Analytics['userSelections']['showDetails']"
          :sUnit="
            Analytics['assetType'] === 'commodity'
              ? Analytics['userSelections']['selectedAsset'][0]['fk_idunit']
              : Analytics['userSelections']['selectedAsset'][
                  'fk_idcurrency_right'
                ]
          "
          :tableFormat="infoTable"
          :unit="
            Analytics['assetType'] === 'commodity'
              ? Analytics['userSelections']['selectedAsset'][0]['fk_idcurrency']
              : Analytics['userSelections']['selectedAsset'][
                  'fk_idcurrency_left'
                ]
          "
          :zoomedData="
            Analytics['rawData'][
              isUserSelectionActiveScenarios
                ? 'totals'
                : `total${Analytics['userSelections']['selectedAnalysis']}`
            ]
          "
          @changeInfoTable="changeInfoTable"
        ></component>
      </div>
    </div>
  </div>
</template>

<script>
import { defaultAnalytics } from "@/_core/data/Analytics/AnalyticsHelpers.js";
import { select } from "d3";
import AnalyticsTable from "@/components/analytics/AnalyticsTable";
import CommodityClients from "./CommodityClients.vue";
import CommodityCounterparty from "./CommodityCounterparty.vue";
import CommodityFilters from "@/components/analytics/CommodityFilters";
import CommodityPDerivatives from "./CommodityPDerivatives.vue";
import CommodityPrice from "./CommodityPrice.vue";
import CommodityPriceStrategies from "./Strategies/CommodityPrice.vue";
import CommodityQtyStrategies from "./Strategies/CommodityQty.vue";
import CommodityStrategyTable from "./Strategies/CommodityTable.vue";
import CommodityProviders from "./CommodityProviders.vue";
import CommodityQDerivatives from "./CommodityQDerivatives.vue";
import CommodityQty from "./CommodityQty.vue";
import CommodityTable from "./CommodityTable.vue";
import CompanyPortProdSelector from "./CompanyPortProdSelector";
import PriceChart from "@/components/analytics/PriceChart";
import QSLoading from "@/components/QSLoading.vue";
import QtyChart from "@/components/analytics/QtyChart";
import Splitter from "../splitter/Splitter.vue";
import SplitterGutter from "../splitter/SplitterGutter.vue";
import SplitterPanel from "../splitter/SplitterPanel.vue";
import CommodityStrategies from "./Strategies/CommodityStrategies.vue";

export default {
  name: "CommodityScenarios",
  components: {
    AnalyticsTable,
    CommodityFilters,
    CompanyPortProdSelector,
    PriceChart,
    QtyChart,
    Splitter,
    SplitterPanel,
    SplitterGutter,
    CommodityPDerivatives,
    CommodityClients,
    CommodityCounterparty,
    CommodityPrice,
    CommodityProviders,
    CommodityQDerivatives,
    CommodityQty,
    CommodityPriceStrategies,
    CommodityQtyStrategies,
    CommodityStrategyTable,
    CommodityStrategies,
    CommodityTable,
    QSLoading,
  },
  props: {
    Analytics: {
      required: true,
      default: defaultAnalytics(),
    },
    colorTheme: { required: true, type: Boolean, default: true },
    companyParametersReady: { required: true, type: Boolean, default: false },
    processData: { required: true },
    screenWidth: { required: false, type: Number, default: 1280 },
    eventElement: { required: false, default: () => PointerEvent },
  },
  data() {
    return {
      chartSizes: {
        sizeSplitterChartPrices: 42,
        sizeSplitterChart: 19.8,
        sizeSplitterTable: 38.2,
      },
      context: {},
      eventParentElement: null,
      formatVar: {
        userHovered: {
          date: "",
          variable: "",
          hovered: false,
          fromChart: false,
        },
      },
      infoTable: [],
      newEventElement: PointerEvent,
      onChangeScenarios: false,
      panels: [],
      showFilters: false,
      userHovered: {
        date: "",
        variable: "",
        hovered: false,
        fromChart: false,
      },
    };
  },
  watch: {
    eventElement(newEvent) {
      const containerChartQty = select(".quantity-xl_height");
      const parentNode =
        containerChartQty.node() && containerChartQty.node().nextSibling;

      this.newEventElement = newEvent;
      this.eventParentElement = parentNode;
      this.onChangeScenarios = true;
    },
    chartSizes: {
      handler: "handleSplitterSizeChange",
      deep: true,
    },
    classChartQty(newVal) {
      if (newVal === "quantity_height") {
        this.chartSizes.sizeSplitterChartPrices = 42;
        this.chartSizes.sizeSplitterChart = 19.8;
        this.chartSizes.sizeSplitterTable = 38.2;
      } else {
        this.chartSizes.sizeSplitterChart = 61.8;
        this.chartSizes.sizeSplitterTable = 38.2;
      }
    },
  },
  computed: {
    normalizeQty() {
      // console.log("normalizeQty")
      return this.Analytics["userSelections"].normalizeQty;
    },
    noDataStr() {
      // console.log("noDataStr")
      return this.Analytics["rawData"]["toBeFetched"]
        ? "Get Information"
        : "No Data Available";
    },
    loadingAll() {
      // console.log("loadingAll")
      const loading = this.Analytics["loading"];
      return (
        loading["derivatives"] ||
        loading["expoFuture"] ||
        loading["expoPast"] ||
        loading["hedgesFuture"] ||
        loading["hedgesPast"] ||
        loading["strategies"]
      );
    },
    renderChartSignal() {
      // console.log("renderChartSignal")
      return this.Analytics["rawData"]["render"];
    },
    AnalyticsUserSelections() {
      // console.log("AnalyticsUserSelections")
      return this.Analytics["userSelections"];
    },
    isUserSelectionActiveScenarios() {
      // console.log("isUserSelectionActiveScenarios")
      const userSelectionAnalysis = this.Analytics["userSelections"][
        "selectedAnalysis"
      ];
      return (
        userSelectionAnalysis === "scenario" ||
        userSelectionAnalysis === "scenarios"
      );
    },
    isUserSelectionActive() {
      // console.log("isUserSelectionActive")
      return (
        this.isUserSelectionActiveScenarios ||
        this.Analytics["userSelections"]["selectedAnalysis"] ===
          "derivatives" ||
        this.Analytics["userSelections"]["selectedAnalysis"] === "strategies"
      );
    },
    classChartQty() {
      const analysis = this.Analytics.userSelections.selectedAnalysis;
      if (
        ["scenario", "scenarios", "derivatives", "strategies"].includes(
          analysis,
        )
      ) {
        return "quantity_height";
      }
      return "quantity-xl_height";
    },
    dynamicChartQty() {
      const selectedAnalysis = this.Analytics.userSelections.selectedAnalysis;
      // console.log("dynamicChartQty", selectedAnalysis);

      if (selectedAnalysis === "strategies") return "CommodityQtyStrategies";
      if (selectedAnalysis === "derivatives") return "CommodityQDerivatives";
      if (selectedAnalysis === "clients") return "CommodityClients";
      if (selectedAnalysis === "providers") return "CommodityProviders";
      if (selectedAnalysis === "counterparty") return "CommodityCounterparty";
      if (this.isUserSelectionActiveScenarios) return "CommodityQty";

      return null; // fallback
    },
    dynamicTable() {
      // console.log("getDynamicTable");
      const selectedAnalysis = this.Analytics["userSelections"][
        "selectedAnalysis"
      ];

      if (selectedAnalysis === "strategies") {
        return "CommodityStrategyTable";
      } else {
        return "CommodityTable";
      }
    },
  },
  methods: {
    changeInfoTable(val) {
      // console.log("changeInfoTable")
      this.infoTable = val;
    },
    handleSplitterSizeChange() {
      // console.log("handleSplitterSizeChange")
      this.$emit("resizeCharts");
    },
    onResizePanel(value) {
      // console.log("onResizePanel")
      this.panels = value.panels;
      if (this.onChangeScenarios) {
        this.sizeSplitters({ isRestore: true });
      } else {
        this.sizeSplitters({});
      }
      this.onChangeScenarios = false;
    },
    onTableFormat(val) {
      // console.log("onTableFormat")
      Object.assign(this.formatVar, {
        userHovered: {
          date: val.date,
          variable: val.variable,
          hovered: val.hovered,
          fromChart: val.fromChart,
        },
      });
    },
    onContext(context) {
      // console.log("onContext")
      this.context = context;
    },
    onRestoreSizes() {
      // console.log("onRestoreSizes")
      this.sizeSplitters({ isRestore: true });
    },
    sizeSplitters({ isRestore = false }) {
      // console.log("sizeSplitters")
      this.panels.forEach((panel) => {
        const el = panel.$el.className;
        const selectElement = select(`.${el.split(" ").join(".")}`);
        if (isRestore) {
          selectElement
            .style("height", `${panel.size}%`)
            .style(
              "flex-basis",
              `calc(${panel.size}% - ${(this.panels.length - 1) *
                this.context.gutterSize}px)`,
            );
        }
      });
      this.$emit("resizeCharts");
    },
    // ==== emits
    onMktRefChange(val) {
      this.$emit("eventOnMktRefChange", val);
    },
    onClientExpandSidebar() {
      let bool = !this.Analytics["userSelections"].expandSidebar;
      this.$emit("eventOnClientExpandSidebar", bool);
    },
    onUserAsset(newValue) {
      this.$emit("eventOnUserAsset", newValue);
    },
    onUserCompany(newValue) {
      this.$emit("eventOnUserCompany", newValue);
    },
    onUserFetchData() {
      this.$emit("eventOnUserFetchData");
    },
    onUserSpotChange(val) {
      this.$emit("eventOnUserSpotChange", val);
    },
    onUserPortfolio(newValue) {
      this.$emit("eventOnUserPortfolio", newValue);
    },
    onUserShowFilters(val) {
      this.showFilters = val;
    },
    onUserFetchExpand() {
      this.$emit("eventOnUserFetchExpand");
    },
    onFilteredData(data) {
      this.$emit("eventOnFilteredData", data);
    },
    onUserFilter(fltr) {
      this.$emit("eventOnUserFilter", fltr);
    },
    onUserShow(str) {
      this.$emit("eventOnUserShow", str);
    },
    onUserZoom(num) {
      this.$emit("eventOnUserZoom", num);
    },
    onUserNormalizeQty() {
      this.$emit("eventOnUserNormalizeQty");
    },
    onUserShowDetails() {
      this.$emit("eventOnUserShowDetails");
    },
    onUserYear(yearNum) {
      this.$emit("eventOnUserYear", yearNum);
    },
  },
};
</script>

<style scoped>
.toggle__button_g .toggle__switch_g::after,
.toggle__button_g .toggle__switch_g::before {
  content: "";
}

.container_chart_prices,
.container_chart_quantity {
  height: calc(100% - 22px);
}

.container-legends_chart_quantity,
.container-chart_chart_quantity {
  height: 100%;
}

.p-splitter {
  border: 0;
  background: 0;
  border-radius: 0;
  color: 0;
}

div.p-splitter .p-splitter-gutter {
  background: 0;
}

.container_table {
  height: 100%;
}
</style>
